import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Text } from '@televet/kibble-ui/build/components/Text';
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@televet/kibble-ui/build/components/Modal';

interface IUnsavedChangesModal {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UnsavedChangesModal = ({ isOpen, onClose, onConfirm }: IUnsavedChangesModal): JSX.Element | null => {
  const handleConfirm = (): void => {
    onConfirm();
    onClose();
  };

  return (
    <Modal size="md" isOpen={isOpen} onClose={onClose}>
      <ModalHeader>Unsaved Changes</ModalHeader>
      <ModalCloseButton />

      <ModalBody>
        <Text>
          This appointment type has unsaved changes. If you exit now, your changes will be lost. Do you wish to exit
          without saving?
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="space-between">
        <Button variant="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleConfirm}>Exit Without Saving</Button>
      </ModalFooter>
    </Modal>
  );
};

export default UnsavedChangesModal;
